import api from '../../../../utils/api';
import { StoredFileMetadata } from '../../../shared/types';

export interface EmploymentDocuments {
    employmentContract?: StoredFileMetadata;
    employerStatement?: StoredFileMetadata;
    payslipOne?: StoredFileMetadata;
    payslipTwo?: StoredFileMetadata;
    payslipThree?: StoredFileMetadata;
}

export interface IncomeSourceEmployment {
    id: string | null;
    homeseekerId: string | null;
    employer: string | null;
    contractType: string | null;
    startDate: string | null;
    grossIncome: number | null;
    incomeFrequency: string | null;
    holidayAllowanceIncluded: boolean | null;
    thirteenthMonthPayIncluded: boolean | null;
    thirtyPercentFacilityApplicable: boolean | null;
    endDate: string | null;
    additionalIncome: number | null;
    additionalIncomeFrequency: string | null;
    additionalIncomeComment: string | null;
}

export interface FindIncomeSourceEmploymentResponse {
    incomeSource: IncomeSourceEmployment;
    documents: EmploymentDocuments;
}

const findIncomeSourceEmployment = async (sourceId: string): Promise<FindIncomeSourceEmploymentResponse> => {
    return await api.getWithoutAuth(`api/screening/income-verification/${sourceId}/documents/employment`);
}

export default findIncomeSourceEmployment;
